const DEFAULT_PIXEL_VALUE = 30 * 60 * 1000;

/**
 * class that calculates a pixel width based off of elapsed time
 * @param {number} pixelValue the base unit of time for one pixel
 * @param {number} startValue start of the block 
 * @param {number} stopValue  end of the block
 */
class Projection {
  #pixelValue;
  constructor({
    pixelValue,
    totalPixels,
    startValue,
    stopValue
  }) {
    this.startValue = startValue;
    this.stopValue = stopValue;
    if (pixelValue) {
      this.#pixelValue = pixelValue;
    } else if (totalPixels) {
      this.#pixelValue = (stopValue - startValue) / totalPixels;
    }
  }
  get pixelValue() {
    if (this.#pixelValue) {
      return this.#pixelValue;
    }
    return DEFAULT_PIXEL_VALUE;
  }
  set pixelValue(newValue) {
    this.#pixelValue = newValue;
  }
  set totalPixels(newValue) {
    this.#pixelValue = (this.stopValue - this.startValue) / newValue;
  }
  startToScreen(value) {
    if (value == null) {
      return this.toScreen(this.startValue);
    }
    return this.toScreen(value);
  }
  stopToScreen(value) {
    if (value == null) {
      return this.toScreen(this.stopValue);
    }
    return this.toScreen(value);
  }
  toScreen(value) {
    return (value - this.startValue) / this.pixelValue;
  }
  toValue(pixel) {
    return pixel * this.pixelValue + this.startValue;
  }
  rangeInPixels() {
    return this.toScreen(this.stopValue) - this.toScreen(this.startValue);
  }
}
export default Projection;